module.exports = __webpack_public_path__ + "static/assets/62c102433fc2d7fc1ca751848aa5bfd6.svg";